import i18n from '@/plugins/i18n';

const paymentSearchBoxInfo = {
  title: i18n.t("label.search"),
  fields: [
    {
      size: 20,
      label: i18n.t("label.started_at"),
      key: "startedAt",
      type: "datepicker",
    },
    {
      size: 20,
      label: i18n.t("label.ended_at"),
      key: "endedAt",
      type: "datepicker",
    },
    {
      size: 20,
      label: i18n.t("label.payer_email"),
      type: "text",
      key: "payerEmail",
      icon: "mail",
    },
    {
      size: 20,
      label: i18n.t("label.payer_name"),
      type: "text",
      key: "payerName",
      icon: "person",
    },
    {
      size: 20,
      label: i18n.t("label.payment_summary"),
      type: "text",
      key: "name",
      icon: "payment",
    },
  ],
};

const feeTextFormFields = [
  {
    label: i18n.t("label.fee_type_name"),
    type: "text",
    model: "name",
    rules: "required",
  },
  {
    label: i18n.t("label.amount_krw"),
    type: "number",
    model: "fee_krw",
    rules: "required|numeric",
  },
  {
    label: i18n.t("label.amount_usd"),
    type: "number",
    model: "fee_usd",
    rules: "required|numeric",
  },
  {
    label: i18n.t("label.memo"),
    type: "text",
    model: "memo",
    rules: "",
  },
];

export { paymentSearchBoxInfo, feeTextFormFields };
